// extracted by mini-css-extract-plugin
export default {"Main_img_slider":"ProductSlider_Main_img_slider__SjG0t","Product_page_thumb_images":"ProductSlider_Product_page_thumb_images__VOZGo"};